module.exports = __webpack_public_path__ + "static/hornsby-19f908b8f5eeca712f038bed340f6273.jpg";